import { LogoMark } from "./Logo";

export const ClearancePass = ({ days = 14, name = "Your name here" }) => (
  <div data-testid="mock-clearance-pass" className="glass rounded-3xl p-5 glow-blue" style={{ transform: "translateZ(40px)" }}>
    <div className="flex items-center justify-between">
      <LogoMark className="w-7 h-7" />
      <span className="font-mono text-[11px] tracking-widest uppercase text-[#10B981] flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" /> Cleared
      </span>
    </div>
    <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Clearance pass · sample</p>
    <p className="font-display text-xl font-bold mt-1 truncate">{name}</p>
    <div className="mt-4 flex items-end justify-between">
      <div>
        <p className="font-display text-5xl font-extrabold text-duo leading-none">{days}</p>
        <p className="text-xs text-slate-400 mt-1">days until next test</p>
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: 14 }).map((_, i) => (
          <span key={i} className={`w-2.5 h-2.5 rounded-sm ${i < 14 - days ? "bg-white/15" : i % 2 ? "bg-[#2F74C4]" : "bg-[#FF2A8D]"}`} />
        ))}
      </div>
    </div>
  </div>
);
